import { renderSlot as _renderSlot, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4c27cc2f")

_pushScopeId("data-v-4c27cc2f")
const _hoisted_1 = { class: "text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: "container",
    onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.forwardToInput && _ctx.forwardToInput(...args)), ["stop"]))
  }, [
    _createVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true),
      (_ctx.hasFile)
        ? (_openBlock(), _createBlock("i", {
            key: 0,
            class: "icon-cancel",
            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.removeFile && _ctx.removeFile(...args)), ["stop"]))
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode("input", {
      ref: "fileInput",
      type: "file",
      accept: _ctx.acceptedFileExt,
      onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleChange && _ctx.handleChange(...args)))
    }, null, 40, ["accept"])
  ]))
})